// extracted by mini-css-extract-plugin
export default {"container":"PromotionalSlider_container__AoYEz","caption":"PromotionalSlider_caption__tBn-y"};